import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20and%20writing%20atmosphere%20with%20books%20scattered%20on%20wooden%20desk%20warm%20amber%20desk%20lamp%20light%20soft%20natural%20morning%20sunlight%20through%20window%20with%20green%20plants%20minimalist%20creative%20workspace%20peaceful%20mood%20editorial%20lifestyle%20photography&width=1600&height=900&seq=hero-powenwang&orientation=landscape"
          alt="po文网 - 原创写作平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
        <h1 className="font-heading text-4xl md:text-6xl text-background-50 mb-4 leading-tight">
          让每一篇好文章
          <br />
          都<span className="text-primary-400">被看见</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          po文网汇聚海量优质原创内容创作者，为你提供便捷的发文工具、精准的读者匹配与良好的创作生态。无论你是写作新手还是资深创作者，这里都是你表达自我的最佳舞台。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-quill-pen-line mr-2"></i>
            开始创作
          </Link>
          <Link
            to="/category"
            className="px-8 py-3 rounded-md bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/30 hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-3-line mr-2"></i>
            浏览文章
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">12,580+</div>
            <div className="text-xs text-background-50/60 mt-1">原创文章</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">8,920+</div>
            <div className="text-xs text-background-50/60 mt-1">活跃创作者</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">350万+</div>
            <div className="text-xs text-background-50/60 mt-1">月活跃读者</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/60"></i>
      </div>
    </section>
  );
}